// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-block-image {
    margin: 0;
}
.softlite-image-size>div{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.softlite-image-size>div .components-text-control__input{
    width: 50%;
}
.softlite-image-size>div label.components-base-control__label{
    margin-bottom: 0px !important;
    text-transform: capitalize;
    font-weight: 400;
    font-size: 13px;
}
.softlite-footer-card-media{
    padding: 0 !important;
    align-items: center !important;
    justify-content: center !important;
}
.block-editor__container img,
.block-editor-iframe__body img {
    max-height: 100% !important;
    max-width: 100%;
}
.softlite-button-remove-image{
    position: absolute;
    right: 0;
    top: 0;
}
.softlite-button-remove-image:focus{
    outline: none !important;
    box-shadow: none !important;
}
.components-card__media img {
    object-fit: cover;
}
.softlite-dynamic-inline .components-input-base{
    flex-direction: row;
    align-items: center;
}
.softlite-dynamic-inline label{
    font-size: 13px !important;
    font-weight: 400 !important;
    text-transform: capitalize !important;
}
.softlite-dynamic-inline .components-flex-item:nth-child(1){
    width: 27%;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/block/image/image.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,UAAU;AACd;AACA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,kCAAkC;AACtC;AACA;;IAEI,2BAA2B;IAC3B,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;AACA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,qCAAqC;AACzC;AACA;IACI,UAAU;AACd","sourcesContent":[".softlite-block-image {\r\n    margin: 0;\r\n}\r\n.softlite-image-size>div{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.softlite-image-size>div .components-text-control__input{\r\n    width: 50%;\r\n}\r\n.softlite-image-size>div label.components-base-control__label{\r\n    margin-bottom: 0px !important;\r\n    text-transform: capitalize;\r\n    font-weight: 400;\r\n    font-size: 13px;\r\n}\r\n.softlite-footer-card-media{\r\n    padding: 0 !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n}\r\n.block-editor__container img,\r\n.block-editor-iframe__body img {\r\n    max-height: 100% !important;\r\n    max-width: 100%;\r\n}\r\n.softlite-button-remove-image{\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n}\r\n.softlite-button-remove-image:focus{\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n}\r\n.components-card__media img {\r\n    object-fit: cover;\r\n}\r\n.softlite-dynamic-inline .components-input-base{\r\n    flex-direction: row;\r\n    align-items: center;\r\n}\r\n.softlite-dynamic-inline label{\r\n    font-size: 13px !important;\r\n    font-weight: 400 !important;\r\n    text-transform: capitalize !important;\r\n}\r\n.softlite-dynamic-inline .components-flex-item:nth-child(1){\r\n    width: 27%;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
